module.exports = __webpack_public_path__ + "img/logo-bts.7d25f859.png";